// AP Elections adapter — keyless STUB for v1. AP requires a paid contract key;
// with none configured this returns an honest "not configured" state (rendered
// as a labeled card, distinct from an outage).
//
// To activate: add AP_API_KEY server-side, add an `ap` entry to the proxy
// allowlist, and implement the fetch + mapping below (races[] → reportingUnits[]
// → candidates[]; precinctsReportingPct → reportingPercent; winner → callStatus).
// The rest of the app already renders whatever NormalizedResult this returns, so
// no UI change is needed to switch it on.
import type { VoteProvider } from '../../types/providers.ts';
import { ProviderError } from '../../types/providers.ts';

export const apProvider: VoteProvider = {
  id: 'ap',
  kind: 'votes',
  async getResults(_race, _cfg, _signal) {
    throw new ProviderError(
      'not_configured',
      'AP Elections API key not configured (licensed feed — add a key to enable).',
    );
  },
};
